import { WemapPinpoint } from '../../../../design-system/components/wemap/types/Wemap';
import { createWemapPlacePinpoint } from '../../../../design-system/components/wemap/utilities/pinpoints';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { PointOfInterest } from '../types/PointOfInterest';

export function formatPointOfInterestIntoWeMapPinPoint(
    pointOfInterest: PickDomain<
        PointOfInterest,
        'id' | 'name' | 'geolocation',
        {
            description?: PointOfInterest['description'];
            picture: PointOfInterest['picture'] | null;
        }
    >,
): WemapPinpoint {
    return createWemapPlacePinpoint({
        id: pointOfInterest.id,
        name: pointOfInterest.name,
        longitude: pointOfInterest.geolocation.middlePoint.longitude,
        latitude: pointOfInterest.geolocation.middlePoint.latitude,
        imageId: pointOfInterest.picture?.id,
    });
}
